module.exports = __webpack_public_path__ + "static/media/report-1.eb57d215.svg";